import {combineReducers} from 'redux';

import {type Action} from 'web-app/util/redux/action-types';

import attendanceSchedules, {type AttendanceScheduleReducer} from './attendance-schedules/reducer';
import attendanceScheduleList, {type AttendanceScheduleListReducer} from './attendance-schedules/list-reducer';
import invoicingProfiles, {type InvoicingProfileReducer} from './overview/reducer';

export interface InvoicingProfileState {
    attendanceSchedules: AttendanceScheduleReducer;
    attendanceScheduleList: AttendanceScheduleListReducer;
    invoicingProfiles: InvoicingProfileReducer;
}

export default combineReducers<InvoicingProfileState, Action<any>>({
    attendanceSchedules,
    attendanceScheduleList,
    invoicingProfiles,
});
